export default __webpack_public_path__ + "static/media/LO11a.d3c1e7df.mp3";